var _CulturePicker;
import React from 'react';
import { CulturePicker } from '../../CulturePicker';
import styled from '@mui/system/styled';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import Alert from '@mui/material/Alert';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ImpersonationHeader(props) {
  if (props === undefined) return /*#__PURE__*/_jsx(_Fragment, {});
  var alertMessage = props.alertMessage,
    alertSeverity = props.alertSeverity,
    enableLogoutButton = props.enableLogoutButton,
    exitButtonDisabled = props.exitButtonDisabled,
    exitButtonLoading = props.exitButtonLoading,
    exitButtonText = props.exitButtonText,
    logoutButtonText = props.logoutButtonText,
    onExitButtonClick = props.onExitButtonClick,
    onLogoutButtonClick = props.onLogoutButtonClick;
  return /*#__PURE__*/_jsxs(RootStack, {
    alignContent: "center",
    direction: "row",
    spacing: 2,
    "data-element": "RootStack",
    "data-component": "ImpersonationHeader",
    "data-source-file": "ImpersonationHeader.tsx",
    children: [/*#__PURE__*/_jsx(Stack, {
      alignContent: "center",
      width: "100%",
      "data-element": "Stack",
      "data-source-file": "ImpersonationHeader.tsx",
      children: /*#__PURE__*/_jsx(Fade, {
        "in": true,
        "data-element": "Fade",
        "data-source-file": "ImpersonationHeader.tsx",
        children: /*#__PURE__*/_jsx(StyledAlert, {
          severity: alertSeverity,
          style: {
            margin: 'auto',
            width: 'auto'
          },
          "data-element": "StyledAlert",
          "data-source-file": "ImpersonationHeader.tsx",
          children: alertMessage
        })
      })
    }), _CulturePicker || (_CulturePicker = /*#__PURE__*/_jsx(CulturePicker, {
      "data-element": "CulturePicker",
      "data-source-file": "ImpersonationHeader.tsx"
    })), /*#__PURE__*/_jsx(LoadingButton, {
      disabled: exitButtonDisabled,
      loading: exitButtonLoading,
      onClick: onExitButtonClick,
      variant: "contained",
      "data-element": "LoadingButton",
      "data-source-file": "ImpersonationHeader.tsx",
      children: exitButtonText
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onLogoutButtonClick,
      sx: enableLogoutButton ? {} : {
        display: 'none'
      },
      variant: "contained",
      "data-element": "Button",
      "data-source-file": "ImpersonationHeader.tsx",
      children: logoutButtonText
    })]
  });
}
var StyledAlert = styled(Alert)(function (_ref) {
  var theme = _ref.theme;
  return {
    '.MuiAlert-message': {
      fontWeight: 'normal'
    },
    minWidth: 'auto'
  };
});
var RootStack = styled(Stack)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    alignItems: 'center',
    height: 100,
    justifyContent: 'space-between',
    padding: theme.spacing(0, 2),
    width: '100%'
  };
});